import Icon from './Icon';

const Practice = (props) => (
  <Icon
    width="48px"
    height="48px"
    viewBox="0 0 48 48"
    {...props}
    color="#7260E0"
  >
    <rect width="48" height="48" rx="24" fill="#7260E0" fillOpacity="0.2" />
    <path
      d="M26.9816 13.0387C26.9816 12.7945 26.8277 12.574 26.5906 12.4784C26.3535 12.3827 26.079 12.4305 25.8932 12.5997L23.6076 14.6818C20.2044 17.7819 17.3287 21.3628 15.0831 25.2971C15.0302 25.3856 15 25.4878 15 25.5967C15 25.933 15.2878 26.2057 15.6428 26.2057H21.1836V34.9611C21.1836 35.2022 21.3338 35.4206 21.5667 35.5181C21.7995 35.6155 22.0711 35.5736 22.2593 35.4112L23.282 34.5287C26.8619 31.4392 29.9 27.8297 32.2823 23.8355L32.9149 22.7748C33.0273 22.5863 33.0256 22.3554 32.9104 22.1683C32.7952 21.9813 32.5838 21.8663 32.3553 21.8663H26.9816V13.0387Z"
      fill="#7260E0"
    />
  </Icon>
);

export default Practice;
